module.exports = __webpack_public_path__ + "static/media/icon_html.f9860a0a.png";